import { IconButton } from "@chakra-ui/react"
import { BsThreeDotsVertical } from "react-icons/bs"
import { MenuContent, MenuRoot, MenuTrigger } from "@/components/ui/menu"
import { ReportJobPublic } from "@/client"
import EditReportJob from "./EditReportJob"
import DeleteReportJob from "./DeleteReportJob"
import { Button } from "@chakra-ui/react"
import { FaCopy } from "react-icons/fa"

interface ActionsMenuWritingProps {
  reportJob: ReportJobPublic
}

export const ActionsMenuReportJob = ({ reportJob }: ActionsMenuWritingProps) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <IconButton variant="ghost" color="inherit" size="sm" aria-label="Open writing actions">
          <BsThreeDotsVertical />
        </IconButton>
      </MenuTrigger>
      <MenuContent zIndex="0">
        <EditReportJob reportJob={reportJob} />

        <Button variant="ghost" size="sm" colorPalette="red">
          <FaCopy fontSize="16px" />
          리포트 생성 작업 복제
        </Button>

        <DeleteReportJob jobId={reportJob.id} />
      </MenuContent>
    </MenuRoot>
  )
}
